module.exports = __webpack_public_path__ + "img/404.1a3cbf84.gif";